<template>
	<div>
		<div v-if="hasValidationErrors" class="alerts bad-bg">
			<ul>
				<li v-for="error in errors" :key="`${ field }-${ error }`"><span class="fa fa-flag"></span>{{ error }}</li>
			</ul>
		</div>

		<!-- On Update - Has a previous file, has not selected a new one -->
		<div v-if="hasCurrentFile && !hasFiles" class="input-container" :class="{ errors: hasValidationErrors }">
			<div class="input-title">Current {{ field.name }}</div>
			<div class="input-static-text">
				<a :href="value[ field.slug + '_filepath' ] + value[ field.slug + '_filename' ]" :download="value[ field.slug + '_original_filename' ]" target="_blank">Download Current File</a>
			</div>
			<div v-if="canRemove" class="input-link">
				<delete-button @deleted="deleteExisting" text="Delete" confirm-text="Confirm Delete"></delete-button>
			</div>
		</div>

		<!-- Has Selected a file -->
		<div v-if="hasFiles" class="input-container" :class="{ errors: hasValidationErrors }">
			<div class="input-title">{{ previewTitle }}</div>
			<div class="input-static-text">{{ fileName }}</div>
			<div class="input-link">
				<a href @click.prevent="clearSelectedFile" class="button"><div class="hover-title">Delete</div><span class="fa fa-times"></span></a>
			</div>
		</div>

		<!-- Select File -->
		<div :key="`select-file-${ field.slug }`" class="input-container" :class="{ errors: hasValidationErrors }">
			<div class="input-title">{{ hasCurrentFile ? 'Replace ' : '' }}{{ field.name }}</div>
			<div class="input-box">
				<label :for="id" class="input-file-upload"><span class="fa fa-cloud-upload"></span>{{ hasFiles || hasCurrentFile ? 'Choose Different' : 'Choose' }} {{ field.name }}</label>
				<input :id="id" :name="field.slug" ref="fileInput" type="file" @change="loadFilesFromFile">
			</div>
		</div>
	</div>
</template>

<script>

import _ from 'underscore';
import CrudField from '@/mixins/CrudField';
import DeleteButton from '@/views/components/DeleteButton';

export default {

	mixins: [CrudField],

	props: {
		current: {
			type: String,
			default: '',
		},
		previewTitle: {
			type: String,
			default: 'File To Upload',
		},
	},

	data() {
		return {
			currentFile: this.current,
			form: { files: [] },
			fileName: null,
			errors: [],
			id: _.uniqueId('file'),
		};
	},

	watch: {
		current(newValue) {
			this.currentFile = newValue;
		},
	},

	computed: {

		hasFiles() {
			return this.form.files && this.form.files.length > 0;
		},

		hasCurrentFile() {
			return (this.currentFile && this.currentFile.length > 0);
		},

		canRemove() {
			// TODO - Cannot delete required files?
			return true;
		},

	},

	methods: {

		loadFilesFromFile(ev) {
			this.errors = [];
			this.form.files = ev.target.files;
			this.fileName = ev.target.files[ 0 ].name;
		},

		clearSelectedFile() {
			this.fileName = null;
			this.form.files = [];
			this.$refs.fileInput.value = '';
		},

		async deleteExisting(done) {
			if (!this.canRemove) return;

			const { data } = await this.$api.post(`module/${this.module.slug}/${this.field.slug}/${this.value.id}/delete`);
			if (data === 1) {
				this.$store.dispatch('addToast', 'File Deleted');
				this.$set(this.value, this.field.slug + '_filepath', null);
				this.$set(this.value, this.field.slug + '_filename', null);
				this.currentFile = '';
			} else {
				return this.$store.dispatch('errorToast',  'There was a problem deleting that file.');
			}

			if (done) {
				done();
			}
		},
	},

	components: {
		DeleteButton,
	},

};

</script>
